document.addEventListener('DOMContentLoaded', function () {
  initFaqAccordion();
  initSmoothScroll();
  initSearchFilter();
  initCardHoverInteraction();
});

function initFaqAccordion() {
  var faqItems = document.querySelectorAll('.pgg-faq-item');

  faqItems.forEach(function (item) {
    var button = item.querySelector('.pgg-faq-item__question');
    var answer = item.querySelector('.pgg-faq-item__answer');

    if (!button || !answer) return;

    button.addEventListener('click', function () {
      var isActive = item.classList.contains('is-active');

      faqItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          otherItem.classList.remove('is-active');
          var otherAnswer = otherItem.querySelector('.pgg-faq-item__answer');
          var otherButton = otherItem.querySelector('.pgg-faq-item__question');
          if (otherAnswer) otherAnswer.style.maxHeight = null;
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        }
      });

      if (isActive) {
        item.classList.remove('is-active');
        answer.style.maxHeight = null;
        button.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initSmoothScroll() {
  var links = document.querySelectorAll('a[href^="#"]');

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;

      var targetEl = document.querySelector(targetId);
      if (!targetEl) return;

      e.preventDefault();
      targetEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
}

function initSearchFilter() {
  var form = document.getElementById('pgg-support-search-form');
  var input = document.getElementById('pgg-support-search-input');

  if (!form || !input) return;

  input.addEventListener('input', function () {
    var query = input.value.trim().toLowerCase();
    var faqItems = document.querySelectorAll('.pgg-faq-item');

    faqItems.forEach(function (item) {
      var questionEl = item.querySelector('.pgg-faq-item__question span');
      var answerEl = item.querySelector('.pgg-faq-item__answer-inner');
      var text = ((questionEl ? questionEl.textContent : '') + ' ' + (answerEl ? answerEl.textContent : '')).toLowerCase();

      if (query === '' || text.indexOf(query) !== -1) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  });
}

function initCardHoverInteraction() {
  var cards = document.querySelectorAll('.pgg-support-card');

  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var centerX = rect.width / 2;
      var centerY = rect.height / 2;
      var rotateX = ((y - centerY) / centerY) * -2;
      var rotateY = ((x - centerX) / centerX) * 2;

      card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-6px)';
    });

    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
